/*! TassenExpress KI-Chat · Widget v4 · Doku: chatbot/docs/TECHNIK.md */
(function () {
'use strict';

// Logik ohne DOM (Tests)
const NR_STD = '4917621355129', MAX = 1000, ZAEHLER_AB = 800;
const HOSTS = ['tassenexpress.store', 'www.tassenexpress.store'];
// Shop: Inhaltsseiten (KONZEPT 2.2)
const ERLAUBT = /^(?!.*\/\/)\/(?:(?:products|collections|pages|policies|blogs)\/[\w.~\/-]*)?$/i;
// einzige Query: Vorlage
const VORLAGE = /^https:\/\/(www\.)?tassenexpress\.store\/products\/tassen-mit-logo-bedrucken-keramik\?vorlage=[a-z0-9-]{1,60}$/;

// Link-Ziel oder null
function linkZiel(roh, nr) {
  nr = nr || NR_STD;
  if (typeof roh !== 'string' || !/^https:\/\//.test(roh) || /[\s\u0000-\u001f\u007f\\]/.test(roh)) return null;
  let u;
  try { u = new URL(roh); } catch (e) { return null; }
  if (u.protocol !== 'https:' || u.username || u.password || u.port) return null;
  if (HOSTS.includes(u.hostname)) return VORLAGE.test(roh) ? u.href : u.search || !ERLAUBT.test(u.pathname) ? null : u.href;
  if (u.hostname !== 'wa.me' || u.hash || (u.pathname !== '/' + nr && u.pathname !== '/' + nr + '/')) return null;
  return 'https://wa.me/' + nr;   // nie ?text= aus einer Antwort (F80)
}

// Linktext: WhatsApp als Nummer, Shop gekürzt
function linkText(href, nr) {
  if (/^https:\/\/wa\.me\//.test(href)) return '+' + String(nr || NR_STD).replace(/^49(\d{3})/, '49 $1 ');
  if (/\?vorlage=/.test(href)) return 'Vorlage öffnen';
  const t = String(href).replace(/^https:\/\/(www\.)?/, '').replace(/\/$/, '');
  return t.length > 36 ? t.slice(0, 35) + '…' : t;
}

// Zeile → Stücke
function segmente(zeile, nr) {
  const out = [];
  let pos = 0;
  zeile = String(zeile);
  for (const m of zeile.matchAll(/https:\/\/[^\s<>"'`]+/g)) {
    const roh = m[0].replace(/[.,;:!?)\]}»«"'“”‘’]+$/, ''), href = linkZiel(roh, nr);
    if (!href) continue;
    if (m.index > pos) out.push({ text: zeile.slice(pos, m.index) });
    out.push({ text: roh, href });
    pos = m.index + roh.length;
  }
  if (pos < zeile.length) out.push({ text: zeile.slice(pos) });
  return out;
}

// Text → Absätze, Listen
function bloecke(text) {
  const out = [];
  let absatz = null, liste = null;
  for (const z of String(text == null ? '' : text).replace(/\r\n?/g, '\n').split('\n')) {
    const zeile = z.replace(/\s+$/, ''), m = /^\s*[-•]\s+(\S.*)$/.exec(zeile);
    if (m) {
      absatz = null;
      if (!liste) out.push(liste = { typ: 'liste', punkte: [] });
      liste.punkte.push(m[1]);
    } else if (!zeile.trim()) absatz = liste = null;
    else {
      liste = null;
      if (absatz) absatz.text += '\n' + zeile;
      else out.push(absatz = { typ: 'absatz', text: zeile });
    }
  }
  return out;
}

// WhatsApp: fester Text, nie die Frage
function waLink(nr, text) {
  const basis = 'https://wa.me/' + (/^\d{8,15}$/.test(String(nr)) ? nr : NR_STD);
  return text ? basis + '?text=' + encodeURIComponent(text) : basis;
}

// https bzw. lokal http
const sicher = u => u.protocol === 'https:' || u.protocol === 'http:' && /^(localhost|127\.0\.0\.1|\[::1\])$/.test(u.hostname);
// data-api: ohne Zugangsdaten/Query
function apiBasis(roh, seite) {
  let u;
  try { u = new URL(roh, seite); } catch (e) { return null; }
  if (!roh || u.username || u.password || u.search || u.hash) return null;
  return sicher(u) ? u.href.replace(/\/+$/, '') : null;
}

function seitenPfad(roh) {
  return /^\/(?![/\\])[^\s"'<>\\]*$/.test(roh || '') ? roh : '/policies/privacy-policy';
}

// Sekunden bis zur Abfrage, 0 = ruhen
function naechsterTakt(takt, modus, offen, fehler) {
  const s = Math.min(Math.max(takt, 2), 60);
  if (!(takt > 0) || fehler >= 5 || !offen && modus !== 'mensch' && s > 5) return 0;
  return Math.min(Math.max(s, offen ? 2 : 5) * 2 ** (fehler || 0), 60);
}

// Bilder: nur Hash-IDs, ≤ 2; Hilfebild mit handy (V-H1 3b)
function bilderPruefen(roh) {
  const mass = x => Number.isInteger(x) && x >= 16 && x <= 4096, ok = b => b && typeof b.id === 'string' && /^[0-9a-f]{64}\.(png|jpg|webp)$/.test(b.id) && mass(b.b) && mass(b.h);
  return Array.isArray(roh) && roh.length <= 2 ? roh.filter(b => ok(b) && typeof b.alt === 'string' && b.alt.length <= 200).map(b => {
    const n = { id: b.id, alt: b.alt, b: b.b, h: b.h }, x = b.handy;
    if (b.art === 'hilfe') { n.art = 'hilfe'; if (ok(x)) n.handy = { id: x.id, b: x.b, h: x.h }; else if (b.nur === 'desktop') n.nur = 1; }
    return n;
  }) : [];
}

// Knopf-Text nur von hier
const KT = ('pages/rabattcodes=🎁 10 % Newsletter-Rabatt|pages/anleitung-vorlage-farbwerte=📄 Vorlage & Farbwerte|products/tassen-mit-logo-bedrucken-keramik=' +
  '☕ Zur Logo-Tasse|collections/all=🛍️ Alle Tassen|pages/datenschutz=🔒 Datenschutz|policies/privacy-policy=🔒 Datenschutz|policies/=📄 Rechtliches|' +
  'products/=☕ Produkt ansehen|collections/=🛍️ Kollektion ansehen|blogs/=📰 Beitrag lesen|pages/=📄 Seite öffnen').split('|').map(x => x.split('='));
const pfad = h => { try { return new URL(h).pathname.toLowerCase().replace(/^\/|\/+$/g, ''); } catch (e) { return ''; } };
function knopfText(h) {
  const p = pfad(h);
  return /^https:\/\/wa\.me\//.test(h) ? '💬 WhatsApp schreiben' : /\?vorlage=/.test(h) ? '🎨 Vorlage öffnen'
    : (KT.find(([k]) => k.endsWith('/') ? p.startsWith(k) : p === k) || [, '🏠 Zum Shop'])[1];
}
// Links am Zeilenende → ende
function knopfTeile(zeile, nr) {
  const teile = segmente(zeile, nr), ende = [];
  for (let i; ;) {
    for (i = teile.length; i-- && !teile[i].href && /^[\s.,;:!?)\]}»«"'“”‘’]*$/.test(teile[i].text);) ;
    if (!(i >= 0 && teile[i].href)) break;
    ende.unshift(teile[i].href);
    teile.length = i;
  }
  const l = teile[teile.length - 1];
  if (ende.length && l && !l.href && !(l.text = l.text.replace(/(\s+[–-]|\s*\()?\s*$/, ''))) teile.pop();
  return { teile, ende, inline: teile.filter(t => t.href).map(t => t.href) };
}
const FORT = /^[\w-]{43}$/;

function absenderText(von, name) {
  if (von !== 'mitarbeiter') return 'KI-Assistent';
  name = typeof name === 'string' ? name.replace(/[\s\p{C}]+/gu, ' ').trim() : '';
  return (Array.from(name).slice(0, 30).join('').trim() || 'Team') + ' · TassenExpress';
}

// /neu (Vertrag 5.2)
function neueNachrichten(d, seqMax, gesehen) {
  const nr = n => n && Number.isInteger(n.seq) && n.seq > 0 ? n.seq : 0;
  const roh = Array.isArray(d.nachrichten) ? d.nachrichten.slice().sort((a, b) => nr(a) - nr(b)) : [], liste = [];
  let ab = seqMax;
  for (const n of roh) {
    const s = nr(n);
    if (s > ab && !gesehen.has(s) && ['ki', 'mitarbeiter', 'system'].includes(n.von) && typeof n.text === 'string' && n.text.trim())
      liste.push({ seq: ab = s, von: n.von, name: n.name, text: n.text.slice(0, n.von === 'system' ? 500 : 4000), bilder: bilderPruefen(n.von === 'ki' && n.bilder) });
  }
  const hoch = Math.max(seqMax, ...roh.map(nr));
  return { liste, seqMax: d.mehr === true ? hoch : Math.max(hoch, Number.isInteger(d.seq) ? d.seq : 0), mehr: d.mehr === true && hoch > seqMax };
}

// Sendungslink nur zu DHL
function dhlLink(roh) {
  let u;
  if (typeof roh !== 'string' || !/^https:\/\/www\.dhl\.(de|com)\/[\w\/.-]*\?[\w=&-]{1,99}$/.test(roh)) return null;
  try { u = new URL(roh); } catch (e) { return null; }
  return /^www\.dhl\.(de|com)$/.test(u.hostname) && !u.port && !u.username && !u.hash ? u.href : null;
}

function assetUrl(roh, seite) {
  let u;
  if (typeof roh !== 'string' || !roh) return null;
  try { u = new URL(roh, seite); } catch (e) { return null; }
  return sicher(u) && !u.username && !u.password ? u.href : null;
}

// Bild: '' = ok, sonst Grund
const BILD_MAX = 10485760, BILD_JE = 3;
function pruefeDatei(f) {
  if (!f || !(f.size > 0)) return 'format';
  if (/^image\/hei[cf]$/.test(f.type) || /\.hei[cf]$/i.test(f.name || '')) return 'heic';
  if (!/^image\/(jpeg|png|webp)$/.test(f.type)) return 'format';
  return f.size > BILD_MAX ? 'gross' : '';
}

// Chat-Link: „tasse“ nur feste Schlüssel
const TL = /^https:\/\/(www\.)?tassenexpress\.store\/products\/[a-z0-9][a-z0-9-]{0,99}\?design=dsg_[\w-]{16,40}$/;
function tassePaket(link, z, f) {
  const t = { ...link ? { link } : { fehlt: /^(leer|pruefen)$/.test(f) ? f : 'fehler' }, farbe: '', hinweise: [] }, n = { menge: 1e5, logos: 20, texte: 50, namen: 2e3 };
  try {
    if (typeof z.farbe == 'string') t.farbe = z.farbe.slice(0, 24);
    for (const k in n) t[k] = Number.isInteger(z[k]) && z[k] > 0 ? Math.min(z[k], n[k]) : 0;
    t.hinweise = ['unscharf', 'weich', 'logo_leer', 'rand_nah', 'qr_offen'].filter(c => [].concat(z.hinweise).includes(c));
  } catch (e) {}
  return t;
}

if (typeof module === 'object' && module && module.exports) module.exports = { linkZiel, linkText, segmente, bloecke, waLink, apiBasis, seitenPfad, MAX,
  naechsterTakt, bilderPruefen, absenderText, neueNachrichten, dhlLink, assetUrl, pruefeDatei, TL, tassePaket, knopfText, knopfTeile };
if (typeof window === 'undefined' || typeof document === 'undefined' || typeof (window.TXChat || {}).oeffnen === 'function') return;

const T = {
  titel: 'Next Level KI-Assistent',
  unter: 'Antworten ohne Gewähr',
  mensch: 'Mitarbeiter im Chat',
  hallo: 'Hallo! Ich bin der KI-Assistent von TassenExpress. Frag mich zu Tassen, Druck, Gestaltung oder Versand.',
  daten: 'Bitte keine persönlichen Daten eingeben · ',
  aus: 'Der Chat ist gerade nicht verfügbar.',
  limit: 'Dieser Chat ist voll. Weiter geht’s per WhatsApp.',
  fehler: 'Das hat nicht geklappt. Versuch es noch mal oder schreib uns per ',
  viel: 'Gerade zu viele Nachrichten. Versuch es später noch mal oder schreib uns per ',
  wa: 'Per WhatsApp schreiben',
  waText: 'Hallo, ich habe eine Frage.',
  platz: 'Deine Frage …',
  bs: '📦 Bestellstatus',
  bsFalsch: 'Bitte Bestellnummer (z. B. 1234) und E-Mail eingeben.',
  rm: '📧 Sollen wir uns per E-Mail bei dir melden?',
  rmInfo: 'Nur für die Antwort auf deine Frage – nach 30 Tagen gelöscht.',
  rmFalsch: 'Bitte eine gültige E-Mail eingeben.',
  format: 'Bitte ein Bild als JPG, PNG oder WebP wählen.',
  heic: 'iPhone-Fotos im HEIC-Format gehen hier nicht – bitte als JPG oder PNG (ein Screenshot geht auch).',
  gross: 'Das Bild ist zu groß (höchstens 10 MB).',
  voll: 'In diesem Chat gehen höchstens 3 Bilder.',
  bildDaten: 'Bitte keine persönlichen Daten auf Bildern (z. B. Adressen oder Bestellungen).',
  lade: 'Bild wird gesendet … ',
  bildFehler: 'Das Bild ging nicht raus. Versuch es noch mal oder schick es per WhatsApp.',
  tasse: '🧩 Hilfe mit meiner Tasse',
  tz: 'schickt dem Team den Link zu deiner Tasse',
  tf: 'Hat gerade nicht geklappt 😕 – tipp oben im Konfigurator aufs Teilen-Symbol ↗',
  fast: '✋ Für deinen Link fehlt noch was: ',
  netz: 'Kein Netz 📶 – versuch’s gleich nochmal, deine Tasse bleibt erhalten.',
  zu: 'Öffne dazu erst deine Tasse im Konfigurator 😊',
  auf: 'Chat öffnen',
  on: ' – wir sind online',
  nlDanke: 'Danke! 📧 Bitte bestätige kurz die E-Mail (schau auch im Spam) – dann kommt dein Rabattcode.',
  nlFehl: 'Das Formular ging nicht auf – hier geht’s zur Seite:',
  vorhin: '↩︎ Dein Chat von vorhin · ',
  neuG: 'Neues Gespräch',
  aelter: 'Ältere Nachrichten ausgeblendet'
};
// Schnellwahl; 📦 nur vom Server
const CHIPS = ['🚚 Lieferzeit', '💶 Preise', '🎨 Vorlagen'];
// Kopieren: Texte nur hier (+ → „Duplizieren“)
const AN = { __proto__: null, logo: 'Logo', motiv: 'Motiv', qr: 'QR-Code', text: 'Text', name: 'Namensfeld' }, SL = { __proto__: null, L: 'links', R: 'rechts' },
  DG = { __proto__: null, mitte: 'Gegenüber dem Henkel geht das nicht+', grenze: 'Über der Feldgrenze geht das nicht+', art: 'Formen gehen hier nicht+',
    zu_breit: 'Zu breit für die andere Seite+', schon_da: 'Steht schon auf beiden Seiten 👍', leer: 'Noch nichts zum Kopieren da 😊',
    geaendert: 'Tasse geändert – frag einfach nochmal 😊', weg: 'Die Kopie ist schon weg.' };
const STUFEN = ['Bezahlt', 'In Arbeit', 'Versendet'];
const STUFE = { zahlung_offen: 0, in_bearbeitung: 1, versendet: 2, teilversendet: 2, zugestellt: 2 };

const I_CHAT = 'M12 3.5c4.7 0 8.5 3.4 8.5 7.6s-3.8 7.6-8.5 7.6c-1.1 0-2.2-.2-3.2-.5L4 20l1.3-3.9a7.2 7.2 0 0 1-1.8-5C3.5 6.9 7.3 3.5 12 3.5Z';
const I_SEND = 'M12 19V5.5M5.5 11.5 12 5l6.5 6.5', I_ZU = 'M6.5 6.5l11 11M17.5 6.5l-11 11', I_AB = 'M6 9.5l6 6 6-6';
const I_DL = 'M12 4v11m-5-5 5 5 5-5M5 19.5h14';
const I_ANH = 'M20 11.6l-8.3 8.3a5.3 5.3 0 0 1-7.5-7.5l8.6-8.6a3.5 3.5 0 0 1 5 5l-8.6 8.6a1.8 1.8 0 0 1-2.5-2.5l7.9-7.9';

// docs/UI-VORGABEN.md
const CSS = `:host{all:initial}
.w{--n:#173586;--in:#4f46e5;--ink:#121a33;--mu:#434a68;--hi:#596079;--fe:cubic-bezier(.34,1.45,.64,1);--pf:blur(18px) saturate(190%) brightness(1.04);--kf:blur(14px) saturate(170%);--ff:blur(12px) saturate(170%);--sf:blur(7px) saturate(190%) brightness(1.05);--pb:radial-gradient(90% 40% at 50% 0,#6366f11f,#6366f100 70%),linear-gradient(165deg,#fff8,#f0f2ff57 42%,#eaedff6b);--bb:linear-gradient(#fffe,#fffc);--kb:linear-gradient(#fff2,#fff0 55%),linear-gradient(150deg,#284aaee6,#173586e6 48%,#3c36bee6);--tb:linear-gradient(#eafbf6f0,#d0f4e9d6);--hb:linear-gradient(#fffd,#fffa);--fb:linear-gradient(#fffd,#fffb);--k1:#f4f6ff80;--k2:#f6f7ffbd;--ko:radial-gradient(120% 170% at 0 0,#fff3,#fff0 48%),linear-gradient(135deg,#173586db,#2838a6d4 52%,#4338cad9);--ab:linear-gradient(#fff3,#fff0 55%),linear-gradient(145deg,#284ab6f2,#173586ed 45%,#483cd4ed);--sb:linear-gradient(150deg,#3860ce9e,#173586ad 50%,#4f46e59e);font:16.5px/1.5 var(--text-font-family,"DM Sans",system-ui,-apple-system,"Segoe UI",sans-serif);color:var(--ink);-webkit-font-smoothing:antialiased}
.rp{--pl:url(#txc-lp) saturate(190%) brightness(1.04)}
.rs{--sl:url(#txc-ls) blur(1.5px) saturate(190%) brightness(1.05)}
*,::before,::after{box-sizing:border-box;margin:0;padding:0;border:0;font:inherit;color:inherit}
[hidden]{display:none!important}
button{background:none;cursor:pointer;-webkit-tap-highlight-color:transparent}
button:disabled{cursor:default}
a{color:var(--n);text-decoration:underline 1px;text-underline-offset:3px}
:focus-visible{outline:3px solid var(--in);outline-offset:2px}
svg,img{display:block;flex:none}
.sr{position:fixed;width:1px;height:1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap}
.defs{position:fixed;width:0;height:0}
.fenster::before,.kopf::before,.start::before,.zu::before,.m::before,.f::before,.log>.h::before,.chip::before,.status::before,.ein::before,.senden::before,.pruefen::before,.nochmal::before,.log .wa::before{content:"";position:absolute;inset:0;z-index:2;pointer-events:none;border-radius:inherit;padding:var(--rb,1px);background:linear-gradient(var(--la,135deg),rgb(255 255 255/var(--r1,.9)),rgb(255 255 255/var(--r2,.18)) 32%,rgb(255 255 255/var(--r3,.05)) 60%,rgb(255 255 255/var(--r4,.5)));-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);mask-composite:exclude}
.zu,.m,.f,.log>.h,.chip,.status,.ein,.senden,.pruefen,.nochmal,.log .wa{position:relative;isolation:isolate}
.start{position:fixed;right:24px;bottom:calc(24px + env(safe-area-inset-bottom,0px) + var(--txc-lift,0px));z-index:900;width:64px;height:58px;border-radius:22px;isolation:isolate;display:grid;place-items:center;color:#fff;background:var(--sb);-webkit-backdrop-filter:var(--sl,var(--sf));backdrop-filter:var(--sl,var(--sf));--rb:1.5px;--r1:1;--r2:.26;--r3:.06;--r4:.7;box-shadow:inset 0 1px 1px #fff9,inset 0 -10px 16px -10px #080e386b,0 2px 4px #1018401f,0 16px 32px -12px #1018408c;transition:transform .5s var(--fe)}
.start::after{content:"";position:absolute;inset:0;z-index:-1;border-radius:inherit;pointer-events:none;background:radial-gradient(60% 50% at var(--lx,32%) var(--ly,16%),#fff8,#fff0 72%)}
.start>img,.start>svg{grid-area:1/1;transition:opacity .2s,transform .45s var(--fe)}
.start>img{width:34px;height:34px;filter:drop-shadow(0 1px 1.5px #080e3859)}
.zi{position:absolute;z-index:3;right:6px;bottom:-9px;width:22px;height:21px;background:var(--zf,#5056bcc0);clip-path:path('M9 10.3A20.5 20.5 0 0 0 22 2.8V21Z')}
.on{position:absolute;z-index:3;top:-4px;right:-4px;width:14px;height:14px;border-radius:50%;background:#22c55e;box-shadow:0 0 0 2.5px #fff}
.on::after{content:"";position:absolute;inset:0;border-radius:50%;background:inherit;pointer-events:none;animation:txc-puls 2.4s cubic-bezier(0,0,.2,1) 5 forwards}
@keyframes txc-puls{0%{transform:scale(1);opacity:.45}70%,to{transform:scale(2.3);opacity:0}}
.rot:not([hidden])+.on,.offen .on,.still .on{display:none}
.start .ch{opacity:0;transform:rotate(-90deg) scale(.6)}
.offen .start>:first-child{opacity:0;transform:rotate(60deg) scale(.5)}
.offen .start .ch{opacity:1;transform:none}
.start:active{transform:scale(.93)}
.verdeckt .start{display:none}
.verdeckt .fenster{z-index:2147483646}
@media (min-width:700px) and (min-height:500px){.verdeckt .fenster{right:var(--txc-fr,24px);bottom:var(--txc-fb,24px);max-width:calc(100vw - var(--txc-fr,24px) - 24px);height:calc(100vh - var(--txc-fb,24px) - 96px)}}
.rot{position:absolute;z-index:3;top:-4px;right:-4px;min-width:22px;height:22px;padding:0 6px;border-radius:11px;background:#e5241b;font-size:13px;font-weight:700;line-height:22px;text-align:center;box-shadow:inset 0 1px 0 #fff5,0 0 0 2px #fffe,0 4px 10px #e5241b66;animation:txc-pop .5s var(--fe)}
@keyframes txc-pop{from{transform:scale(.3);opacity:0}}
.fenster{position:fixed;right:24px;bottom:calc(102px + var(--txc-lift,0px));z-index:900;width:408px;max-width:calc(100vw - 48px);height:calc(100vh - 118px - var(--txc-lift,0px));max-height:660px;isolation:isolate;overflow:hidden;border-radius:34px;background:var(--pb);-webkit-backdrop-filter:var(--pl,var(--pf));backdrop-filter:var(--pl,var(--pf));box-shadow:inset 0 1px 1px #fffb,inset 0 -1px 1px #fff5,inset 0 0 24px -8px #fff6,inset 0 -28px 42px -34px #141c546b,0 2px 6px #1018400f,0 24px 50px -22px #10184057,0 70px 120px -50px #10184080;transform-origin:calc(100% - 31px) calc(100% + 48px);opacity:0;visibility:hidden;transform:translateY(18px) scale(.9);transition:opacity .18s,transform .28s cubic-bezier(.2,.8,.2,1),visibility 0s .28s}
.fenster::before{z-index:6;--rb:1.5px;--r1:.95;--r2:.22;--r3:.06;--r4:.62}
.fenster::after{content:"";position:absolute;inset:0;z-index:-1;pointer-events:none;border-radius:inherit;background:radial-gradient(400px 280px at var(--lx,16%) var(--ly,-4%),#fff6,#fff0 64%),radial-gradient(70% 30% at 100% 104%,#fff5,#fff0 70%),linear-gradient(to top,#fff8,#fff0 130px)}
.offen .fenster{opacity:1;visibility:visible;transform:none;transition:opacity .2s,transform .62s var(--fe),visibility 0s}
.kopf{position:absolute;z-index:3;top:10px;left:10px;right:10px;display:flex;align-items:center;gap:11px;min-height:64px;padding:10px 10px 10px 16px;border-radius:24px;color:#fff;background:var(--ko);-webkit-backdrop-filter:var(--kf);backdrop-filter:var(--kf);--r1:.75;--r2:.18;--r3:.05;--r4:.42;box-shadow:inset 0 1px 0 #fff5,inset 0 -12px 22px -18px #080e3880,0 1px 2px #10184014,0 14px 30px -16px #10184080}
.kopf :focus-visible{outline-color:#fff}
.logo{height:22px;width:auto}
.lt{font-size:15px;font-weight:700;letter-spacing:-.01em}
.tr{flex:none;width:1px;height:32px;background:#fff6}
.kt{min-width:0;flex:1}
.name{font-size:clamp(15px,4.2vw,17px);font-weight:650;line-height:1.2;letter-spacing:-.012em}
.unter{margin-top:2px;font-size:13.5px;line-height:1.3;color:#fffe}
.zu{flex:none;width:40px;height:40px;border-radius:50%;display:grid;place-items:center;background:linear-gradient(#fff5,#fff2);--r1:.85;--r4:.35;box-shadow:inset 0 1px 0 #fff7,inset 0 -6px 10px -6px #080e384d,0 4px 10px -6px #080e3873;transition:transform .4s var(--fe)}
.log{position:absolute;inset:0;z-index:1;overflow-y:auto;overscroll-behavior:contain;display:flex;flex-direction:column;gap:10px;padding:calc(var(--ku,74px) + 14px) 16px 0;scrollbar-width:thin;scrollbar-color:#1735864d transparent}
.log::after{content:"";flex:none;height:calc(var(--fh,102px) + 2px)}
.kante{position:absolute;left:0;right:0;z-index:2;pointer-events:none;-webkit-backdrop-filter:blur(7px);backdrop-filter:blur(7px)}
.ko{top:0;height:calc(var(--ku,74px) + 14px);background:linear-gradient(var(--k1),#fff0);mask:linear-gradient(#000 50%,#0000)}
.ku{bottom:0;height:calc(var(--fh,102px) + 20px);background:linear-gradient(0deg,var(--k2) 44px,var(--k1) 68px,#fff0);mask:linear-gradient(0deg,#000 62%,#0000)}
.m,.f{align-self:flex-start;max-width:86%;padding:11px 15px;border-radius:22px 22px 22px 8px;background:var(--bb);white-space:pre-wrap;overflow-wrap:anywhere;animation:txc-rein .42s var(--fe) both;box-shadow:inset 0 1px 0 #fff,inset 0 -10px 18px -14px #17286e29,0 1px 2px #1018400d,0 10px 24px -14px #10184052}
@keyframes txc-rein{from{opacity:0;transform:translateY(10px) scale(.96)}}
.m>*+*,.f>*+*{margin-top:10px}
.m>.von+*{margin-top:4px}
.m ul{padding-left:20px}
.du{align-self:flex-end;color:#fff;background:var(--kb);border-radius:22px 22px 8px;--r1:.55;--r2:.12;--r3:.02;--r4:.28;box-shadow:inset 0 1px 0 #fff5,inset 0 -12px 20px -14px #04083080,0 12px 24px -14px #173586b3}
.von{font-size:13px;font-weight:600;line-height:1.3;color:var(--mu)}
.m:not(.mensch)>.von::before{content:"✨ "}
.mensch{color:#0b3b36;background:var(--tb);--r1:.95;--r4:.5;box-shadow:inset 0 1px 0 #fffe,inset 0 -10px 18px -14px #0f766e52,0 10px 24px -14px #0f766e73}
.mensch .von{color:#0f5f58}
.mensch>.von::after{content:"Team";display:inline-block;margin-left:6px;padding:1px 8px;border-radius:99px;background:#0f766e21;color:#065f46;box-shadow:inset 0 0 0 1px #0f766e2e}
.log>.h{align-self:center;max-width:92%;padding:6px 14px;border-radius:18px;text-align:center;font-size:13.5px;font-weight:500;line-height:1.35;color:#2c3454;background:var(--hb);box-shadow:inset 0 -6px 10px -8px #1735862e,0 4px 12px -8px #10184059}
.h a{color:inherit}
.tipp{display:inline-flex;align-items:center;gap:10px;font-size:14.5px;color:var(--mu)}
.pk{display:inline-flex;gap:4px}
.pk i{width:7px;height:7px;border-radius:50%;background:#5866b4;animation:txc-hops 1.1s ease-in-out infinite}
.pk i+i{animation-delay:.15s}.pk i+i+i{animation-delay:.3s}
@keyframes txc-hops{0%,60%,100%{transform:none;opacity:.45}30%{transform:translateY(-4px);opacity:1}}
.f{background:#fee9e8f0}
.senden,.nochmal,.pruefen{border-radius:99px;color:#fff;font-weight:700;background:var(--ab);--r1:.8;--r4:.35;box-shadow:inset 0 1px 0 #fff7,inset 0 -8px 14px -8px #080e3866,0 8px 18px -10px #173586b3;transition:transform .45s var(--fe),opacity .2s}
.nochmal{display:block;padding:8px 18px;font-size:15px}
.pruefen{width:100%;min-height:48px;font-size:16px}
.pruefen:disabled{opacity:.6}
.chips{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin:2px 0 4px;animation:txc-rein .42s var(--fe) both}
.chip,.log .wa{border-radius:99px;color:var(--n);background:var(--hb);box-shadow:inset 0 1px 0 #fff,inset 0 -8px 14px -10px #1735863d,0 0 0 1px #17358614,0 8px 18px -12px #10184066;transition:transform .45s var(--fe)}
.chip{display:flex;align-items:center;justify-content:center;min-height:46px;padding:9px 14px;font-size:15.5px;font-weight:600;line-height:1.2}
.chip:last-child:nth-child(odd){grid-column:span 2}
.eins{display:flex;flex-direction:column;text-align:center}
.chip:active{transform:scale(.95)}
a.chip{text-decoration:none}
a.lk{padding:0 9px;border-radius:99px;background:#1735861a;font-weight:600;text-decoration:none;white-space:nowrap}
.h button{font-weight:600;text-decoration:underline}
.karte{width:94%;max-width:94%;white-space:normal}
.karte label{display:grid;gap:4px;font-size:13.5px;font-weight:600;color:var(--mu)}
.karte input{width:100%;min-height:46px;padding:10px 14px;border-radius:14px;background:var(--fb);font-size:16px;font-weight:400;color:var(--ink);box-shadow:inset 0 1px 3px #1018401f,inset 0 0 0 1px #1735862e,0 1px 0 #fffe}
.karte input::placeholder{color:var(--hi);opacity:1}
.karte input:focus{outline:0;box-shadow:inset 0 1px 3px #1018401f,inset 0 0 0 1.5px var(--in),0 0 0 4px #4f46e538}
.karte .h{font-size:14px;font-weight:500}
.dv{width:auto;display:flex;align-items:center;gap:12px;font-weight:600;color:var(--ink);text-decoration:none}
.dv .senden{width:52px;height:52px}
.dv .ds{display:block;font-weight:400}
.karte .h:empty{display:none}
.status{border-radius:18px;padding:12px;background:linear-gradient(#fffe,#f5f7ffc2);box-shadow:inset 0 1px 0 #fff,inset 0 -10px 18px -14px #17358633,0 0 0 1px #4f46e51a,0 8px 20px -14px #17358673}
.sk{position:relative;min-height:42px;padding-left:53px;font-size:14px;color:var(--mu)}
.si{position:absolute;left:0;top:0;width:42px;height:42px;border-radius:14px;display:grid;place-items:center;font-size:21px;background:linear-gradient(#eef1ff,#dfe5fb);box-shadow:inset 0 1px 0 #fff,inset 0 -4px 8px -4px #17358633}
.gross{font-size:16.5px;font-weight:700;line-height:1.3;color:var(--ink)}
.sk p:not(.gross){display:inline}
.sk a{font-weight:600;color:inherit}
.sk p:not(.gross)+a::before{content:"·";display:inline-block;margin:0 6px;color:var(--mu)}
.st{list-style:none;display:grid;grid-template-columns:repeat(3,1fr);margin-top:12px;font-size:13px;line-height:1.25;color:var(--mu);text-align:center;white-space:nowrap}
.st li{position:relative;display:grid;justify-items:center;gap:6px}
.st li::before{content:"";position:absolute;top:6px;left:-50%;width:100%;height:2px;background:#dfe3f0}
.st li:first-child::before{display:none}
.st .ok::before,.st .jetzt::before{background:linear-gradient(90deg,var(--n),var(--in))}
.st i{position:relative;z-index:1;width:14px;height:14px;border-radius:50%;background:#fff;border:2px solid #cdd3e6}
.st .ok i{background:var(--n);border-color:var(--n)}
.st .jetzt i{border:4px solid var(--in);box-shadow:0 0 0 4px #4f46e52e,0 0 12px #4f46e573}
.st .jetzt{color:var(--ink);font-weight:600}
.bild{display:block}
.bild img{max-width:100%;height:auto;max-height:240px;object-fit:contain;border-radius:14px}
.hilfe img{max-height:300px}
.wa{display:inline-flex;align-items:center;gap:6px;font-weight:600;text-decoration:none}
.log .wa{align-self:center;min-height:42px;padding:9px 16px;font-size:15px;font-weight:700}
.fuss{position:absolute;z-index:3;left:0;right:0;bottom:0;padding:0 12px 6px}
.ein{display:flex;align-items:flex-end;gap:8px;min-height:56px;padding:6px 6px 6px 20px;border-radius:28px;background:var(--fb);-webkit-backdrop-filter:var(--ff);backdrop-filter:var(--ff);--r1:1;--r4:.55;box-shadow:inset 0 1px 1px #fffe,inset 0 -10px 18px -14px #17286e38,0 0 0 1px #17358614,0 12px 28px -14px #10184073;transition:box-shadow .2s}
.ein:focus-within{outline:2px solid #4f46e58c}
textarea{flex:1;min-width:0;min-height:44px;max-height:132px;padding:10px 0;resize:none;background:none;font-size:16.5px;line-height:1.45;overflow-y:hidden}
textarea::placeholder{color:var(--hi);opacity:1}
textarea:focus{outline:0}
textarea:disabled{opacity:.7}
.senden,.anh{width:44px;height:44px;display:grid;place-items:center;flex:none}
.anh{margin-left:-14px;border-radius:50%;color:var(--n);transition:transform .45s var(--fe)}
.anh:active:not(:disabled){transform:scale(.9)}
.anh:disabled{opacity:.42}
.vor{display:flex;align-items:center;gap:6px;width:max-content;margin:0 0 6px 8px;padding:5px;border-radius:18px;background:var(--hb);box-shadow:inset 0 1px 0 #fff,0 0 0 1px #17358614,0 8px 18px -12px #10184066}
.vor img{width:52px;height:52px;object-fit:cover;border-radius:13px}
.vor button{width:34px;height:34px;display:grid;place-items:center;border-radius:50%;color:var(--mu)}
.du img{max-width:100%;max-height:240px;height:auto;border-radius:14px}
.du .bs{font-size:13.5px}
.senden:disabled{opacity:.42;box-shadow:inset 0 1px 0 #fff7}
.senden:active:not(:disabled),.dv:active .senden{transform:scale(.9)}
.zahl{padding:4px 14px 0;text-align:right;font-size:13px;color:var(--mu)}
.uz{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:6px 8px 0;font-size:14px}
.uz .wa{min-height:34px}
.ds{font-size:13.5px;color:var(--mu)}
.eng .uz,.gesperrt .uz{display:none}
@media (hover:hover) and (pointer:fine){.start:hover,.zu:hover,.senden:not(:disabled):hover,.dv:hover .senden{transform:scale(1.07)}.chip:hover,.log .wa:hover,.pruefen:not(:disabled):hover,.nochmal:hover{transform:translateY(-2px) scale(1.02)}.uz .wa:hover{text-decoration:underline}}
@media (max-width:699px),(max-height:499px){.start{right:18px;bottom:calc(18px + env(safe-area-inset-bottom,0px) + var(--txc-lift,0px))}
.offen .start{display:none}
.fenster{top:var(--txc-vt,0px);right:0;bottom:auto;left:0;z-index:99999990;width:auto;max-width:none;height:var(--txc-vh,100vh);max-height:none;border-radius:0;box-shadow:0 480px 0 #f3f4fd;transform-origin:50% 100%;--pl:initial;--pf:blur(28px) saturate(180%) brightness(1.03);--pb:radial-gradient(100% 30% at 50% 0,#6366f11a,#6366f100 70%),linear-gradient(#f8f9ffa3,#f1f3ff85 50%,#f6f7ff9e)}
.fenster::before{display:none}
.kopf{top:calc(6px + env(safe-area-inset-top,0px))}
.logo{height:18px}
.m:not(.karte){max-width:84%}
.fuss{padding-bottom:calc(8px + env(safe-area-inset-bottom,0px))}
.eng .fuss{padding-bottom:8px}}
@media (prefers-contrast:more){.w{--mu:#2f3654;--hi:#454c66}}
@media (forced-colors:active){.fenster,.kopf,.m,.f,.chip,.status,.ein,.log>.h,.start,.zu,.senden,.pruefen,.nochmal{border:1px solid CanvasText}}
@media (prefers-reduced-transparency:reduce),(prefers-contrast:more){.w,.w .fenster{--pf:none;--kf:none;--ff:none;--sf:none;--pl:initial;--sl:initial;--pb:#f3f5fc;--bb:#fff;--kb:#173586;--tb:#e3f6ef;--hb:#fff;--fb:#fff;--k1:#f3f5fc;--k2:#f3f5fc;--ko:linear-gradient(135deg,#173586,#3730a3);--ab:var(--ko);--sb:var(--ko);--zf:#3730a3}.fenster::after,.start::after{display:none}.kante{-webkit-backdrop-filter:none;backdrop-filter:none}}
@media (prefers-reduced-motion:reduce){*,::before,::after{animation:none!important;transition-duration:.01ms!important}.w .fenster,.w :hover,.w :active{transform:none!important}.pk i+i{opacity:.7}}`;

const ds = ((document.currentScript || document.querySelector('script[data-api][src*="tx-chat"]') || {}).dataset) || {};
const API = apiBasis(ds.api, location.href), NR = /^\d{8,15}$/.test(ds.whatsapp || '') ? ds.whatsapp : NR_STD;
const WA = waLink(NR, T.waText), NEU = { target: '_blank', rel: 'noopener noreferrer' };
const LOGO = assetUrl(ds.logo, location.href), TASSE = assetUrl(ds.tasse, location.href);
if (!API) { console.warn('[TXChat] data-api ungültig'); T.on = ''; }

// DOM nur über textContent
function el(tag, a, ...kinder) {
  const e = /^(svg|path|filter|fe\w+)$/.test(tag) ? document.createElementNS('http://www.w3.org/2000/svg', tag) : document.createElement(tag);
  if (tag === 'button') e.type = 'button';
  for (const k in a) {
    const v = a[k];
    if (k === 'text') e.textContent = v;
    else if (k.slice(0, 2) === 'on') e.addEventListener(k.slice(2), v);
    else if (v != null && v !== false) e.setAttribute(k, v === true ? '' : v);
  }
  for (const k of kinder) if (k != null) e.append(k);
  return e;
}
function icon(gr, d, strich, cls) {
  return el('svg', { class: cls, viewBox: '0 0 24 24', width: gr, height: gr, 'aria-hidden': 'true', fill: 'none', stroke: 'currentColor',
    'stroke-width': strich || 2.2, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }, el('path', { d }));
}

// nur im Arbeitsspeicher
let gespraech = null, fehlerBox = null, sperrKnopf = null, sp = {};
let offen = false, modal = false, wartet = false, gesperrt = false, begruesst = false, leiste = null, leisteBeob = null, raf = 0;
let seqMax = 0, gesehen = new Set(), modus = 'ki', takt = 0, ungelesen = 0, fehlerN = 0, uhr = 0, mitMensch = 0, nachgeholt = 0, nachFehl = 0, unterKi = T.unter;
let chips = null, karte = null, markiert = '';
let bild = null, bilderN = 0, bildHinweis = 0, zuletzt = null;
let tasseAn, tChip, GS = 0, dupL = 0, dupZ, GB, GZ = 0;   // GS: 🧩 getippt; GB: Bild-Stand; GZ: pageshow
let ku = 74, fh = 102;
let amEnde = true;
let HILFE = {}, merk = speicherLesen(), nl = 0, geschrieben = 0, neuK;
const OV = 'body > .tk-overlay:not(.tk-headless)';
const MQ = matchMedia('(max-width: 699px), (max-height: 499px)'), FEIN = matchMedia('(pointer: fine)'), VV = window.visualViewport;
const HQ = matchMedia('(max-width:1099px)');
const RUHIG = matchMedia('(prefers-reduced-motion: reduce)'), WENIG = matchMedia('(prefers-reduced-transparency: reduce)');

const host = el('tx-chat', { 'data-clarity-mask': 'true', 'data-hj-suppress': true });
const root = host.attachShadow({ mode: 'closed' });
const rot = el('span', { class: 'rot', hidden: true }), ansage = el('span', { class: 'sr', role: 'status' });
const lt = () => el('span', { class: 'lt', text: 'TassenExpress' }), blase = () => icon(26, I_CHAT, 1.9);
const tasse = TASSE ? el('img', { src: TASSE, alt: '', width: 34, height: 34, onerror: () => tasse.replaceWith(blase()) }) : blase();
const logo = LOGO ? el('img', { class: 'logo', src: LOGO, alt: 'TassenExpress', width: 82, height: 22, onerror: () => logo.replaceWith(lt()) }) : lt();
const start = el('button', { class: 'start', 'aria-label': T.auf + T.on, 'aria-expanded': 'false', 'aria-controls': 'txc-fenster',
  onclick: () => offen ? schliessen() : oeffnen() }, tasse, icon(26, I_AB, 2.2, 'ch'), rot, el('i', { class: 'on' }), el('i', { class: 'zi' }));
const titel = el('div', { class: 'name', text: T.titel });
const unter = el('div', { class: 'unter', text: T.unter });
const log = el('div', { class: 'log', role: 'log', 'aria-live': 'polite', 'aria-label': 'Nachrichten' });
const feld = el('textarea', { rows: 1, maxlength: MAX, placeholder: T.platz, 'aria-label': 'Deine Nachricht', enterkeyhint: 'send', autocomplete: 'off' });
const senden = el('button', { class: 'senden', 'aria-label': 'Senden', disabled: true, onclick: () => { schicke(); fokus(feld); } }, icon(22, I_SEND, 2.3));
const zahl = el('div', { class: 'zahl', hidden: true });
const tipp = el('div', { class: 'm tipp' }, el('span', { class: 'pk', 'aria-hidden': 'true' }, el('i'), el('i'), el('i')), 'schreibt …');
const zu = el('button', { class: 'zu', 'aria-label': 'Chat schließen', onclick: schliessen }, icon(20, I_ZU));
const kopf = el('div', { class: 'kopf' }, logo, el('span', { class: 'tr' }), el('div', { class: 'kt' }, titel, unter), zu);
const datei = el('input', { type: 'file', accept: 'image/*', hidden: true, tabindex: -1, 'aria-hidden': 'true', onchange: waehle });
const anh = el('button', { class: 'anh', 'aria-label': 'Bild anhängen', hidden: true, onclick: () => datei.click() }, icon(22, I_ANH, 2));
const vor = el('div', { class: 'vor', hidden: true });
const ein = el('div', { class: 'ein' }, anh, feld, senden, datei);
const fuss = el('div', { class: 'fuss' }, vor, ein, zahl,
  el('div', { class: 'uz' }, waKnopf(), el('a', { class: 'ds', href: seitenPfad(ds.datenschutz), ...NEU, text: 'Datenschutz' })));
const fenster = el('div', { id: 'txc-fenster', class: 'fenster', role: 'dialog', 'aria-label': T.titel, 'aria-modal': 'false', onkeydown: taste, onpointerenter: tasseChip },
  kopf, log, el('div', { class: 'kante ko' }), el('div', { class: 'kante ku' }), fuss);
const wrap = el('div', { class: API ? 'w' : 'w still' }, start, ansage, fenster);
root.append(el('style', { text: CSS }), wrap);

function waKnopf() { return el('a', { class: 'wa', href: WA, ...NEU }, el('span', { 'aria-hidden': 'true', text: '💬' }), T.wa); }
function fokus(x) { if (x) x.focus({ preventScroll: true }); }
function fokusEin() { fokus(feld.disabled || !FEIN.matches ? zu : feld); }   // Handy: keine Tastatur
function stil(n, v) { host.style.setProperty('--txc-' + n, v + 'px'); }

// Esc; Tab bleibt im Fenster
function taste(e) {
  e.stopPropagation();
  if (e.key === 'Escape') { schliessen(); return; }
  if (e.key !== 'Tab' || !modal) return;
  const f = [...fenster.querySelectorAll('a[href],button:not(:disabled),textarea:not(:disabled),input:not(:disabled)')].filter(x => x.getClientRects().length);
  const i = f.indexOf(root.activeElement), n = f.length - 1;
  if (e.shiftKey ? i <= 0 : i < 0 || i === n) { e.preventDefault(); fokus(f[e.shiftKey ? n : 0]); }
}

let zurueck, vd;
function oeffnen() {
  umgebung();
  if (!offen) zurueck = document.activeElement;
  if (!begruesst) {
    begruesst = true;
    if (!API) sperre(T.aus);
    else if (merk = speicherLesen()) verlauf();
    else hallo();
  }
  if (!offen) { umschalten(true); log.scrollTop = log.scrollHeight; }
  fokusEin();
}
function hallo() {
  zeigeBot(T.hallo);
  zeige(el('p', { class: 'h' }, T.daten, el('a', { href: seitenPfad(ds.datenschutz), ...NEU, text: 'Datenschutz' })));
  holeStatus();   // Serverkontakt erst beim Öffnen
}
function schliessen() {
  if (!offen) return;
  const drin = !!root.activeElement;
  umschalten(false);
  if (drin) fokus(vd && (zurueck && zurueck.isConnected !== false && zurueck !== document.body ? zurueck : document.querySelector(OV + ' .tk-rail-hilfe')) || start);
}
function umschalten(an) {
  offen = an;
  wrap.classList.toggle('offen', an);
  start.setAttribute('aria-expanded', String(an));
  zaehle(0);
  anpassen();
  planeAbfrage(an);
  if (an) { masse(); linsePlanen(); }
}

// Handy: Vollbild; <body> des Konfigurators bleibt
function anpassen() {
  const ui = { h: document.documentElement.style, b: document.body.style }, kf = !!document.querySelector(OV);
  modal = offen && MQ.matches;
  fenster.setAttribute('aria-modal', String(modal));
  wrap.classList.toggle('eng', modal && ((VV ? VV.height : innerHeight) < 420 || (VV && innerHeight - VV.height > 150)));
  if (modal) {
    stil('vh', Math.round(VV ? VV.height : innerHeight));
    stil('vt', Math.round(VV ? VV.offsetTop : 0));
    if (amEnde) requestAnimationFrame(zumEnde);
  }
  for (const k in ui) {
    const s = ui[k], fremd = k === 'b' && kf;
    if (modal && !fremd && !(k in sp)) { sp[k] = s.overflow; s.overflow = 'hidden'; }
    else if (!modal && !fremd && k in sp) { if (s.overflow === 'hidden') s.overflow = sp[k]; delete sp[k]; }
  }
}

// Kasse-Leiste, Konfigurator, 🧩
function umgebung() {
  raf = 0;
  const b = document.querySelector('.ts-checkout-bar');
  if (b !== leiste) {
    leiste = b;
    if (leisteBeob) leisteBeob.disconnect();
    if (b) (leisteBeob = new MutationObserver(planen)).observe(b, { attributes: true, attributeFilter: ['class'] });
  }
  stil('lift', b && b.classList.contains('ts-visible') ? Math.ceil(b.getBoundingClientRect().height) : 0);
  const v = !!document.querySelector(OV);
  if (v && offen && !vd) schliessen();
  wrap.classList.toggle('verdeckt', vd = v);
  if (v) {
    const q = s => { const e = document.querySelector(OV + ' .tk-' + s); return e && e.getBoundingClientRect(); },
      r = q('rail'), f = q('footer.tk-active'), quer = r && r.width > r.height;
    stil('fr', r && !quer ? innerWidth - r.left + 12 : 24);
    stil('fb', Math.max(24, innerHeight - Math.min(f ? f.top : innerHeight, quer ? r.top : innerHeight) + 12));
  }
  anpassen();
  tasseChip();
}
function planen() { if (!raf) raf = requestAnimationFrame(umgebung); }

function zumEnde() {
  const k = log.lastElementChild;
  log.scrollTop = k && k.offsetHeight > log.clientHeight - ku - fh - 32 ? k.offsetTop - ku - 8 : log.scrollHeight;
  amEnde = true;
}
function zeige(k) { log.append(k); zumEnde(); }
function zeileIn(ziel, text) {
  for (const s of segmente(text, NR)) ziel.append(s.href ? el('a', { href: s.href, target: '_blank', rel: 'noopener noreferrer nofollow', text: linkText(s.href, NR) }) : s.text);
  return ziel;
}
// Knöpfe (V-H1 8): Zeilenende → Reihe r (≤ 3), sonst Pille
function zeileK(ziel, text, r) {
  if (!HILFE.k) return zeileIn(ziel, text);
  let voll = 0;
  for (const z of text.split('\n')) {
    const k = knopfTeile(z, NR);
    for (const h of k.ende) r.includes(h) || (r.length < 3 ? r.push(h) : k.teile.push({ text: k.teile[0] ? ' ' : '' }, { href: h }));
    if (k.teile[0] && voll++) ziel.append('\n');
    for (const s of k.teile) ziel.append(s.href ? knopf(s.href, 'lk') : s.text);
  }
  return voll ? ziel : null;
}
// Shop-Link im selben Tab nur mit Verlauf, ohne Konfigurator
function knopf(h, c) {
  const a = el('a', { class: c, href: h, ...NEU, rel: 'noopener noreferrer nofollow', text: knopfText(h), onclick: e => {
    const r = pfad(h) == 'pages/rabattcodes';
    if (r && popup(e, h)) return;
    if (r) melde('nl_link');
    a.setAttribute('target', r || /^https:\/\/wa/.test(h) || vd || !speicherLesen() ? '_blank' : '_self');
  } });
  return a;
}
// Klaviyo-Popup (V-H1 9); nl 1 offen, 2 Rückfall
function popup(e, h) {
  const id = HILFE.nl, k = window._klOnsite, handy = MQ.matches, cmd = ['openForm', id];
  if (!id || vd || !k || typeof k.push != 'function' || nl > 1) return;
  e.preventDefault();
  if (nl) return 1;
  nl = 1;
  melde('nl_popup');
  if (handy) schliessen();
  let danke = 0, auf = 0;
  const weg = () => { removeEventListener('klaviyoForms', hoer); nl = 0; }, hoer = ({ detail: d }) => {
    if (!d || d.formId !== id) return;
    if (d.type == 'open') { if (nl > 1 && handy) schliessen(); nl = auf = 1; }
    if (d.type == 'submit' && !danke++) zeigeHinweis(T.nlDanke);   // erst „X“ holt den Chat
    if (d.type == 'close') { weg(); if (handy) oeffnen(); }
  };
  addEventListener('klaviyoForms', hoer);
  setTimeout(() => {
    const f = document.querySelector(`[data-testid="klaviyo-form-${id}"]`);   // per openForm kommt kein „open“
    if (f && f.offsetParent) auf = 1;
    if (auf || nl != 1) return;
    nl = 2;
    if (Array.isArray(k) && k.includes(cmd)) k.splice(k.indexOf(cmd), 1);   // nicht spät öffnen
    if (handy) oeffnen();
    zeigeHinweis(T.nlFehl); zeige(el('div', { class: 'chips eins' }, el('a', { class: 'chip', href: h, ...NEU, text: knopfText(h) }))); melde('nl_link');
    setTimeout(() => nl > 1 && weg(), 15000);
  }, 2000);
  try { k.push(cmd); } catch (x) {}
  return 1;
}
// KI-Blasen nennen sich, wenn ein Mensch dabei war
function zeigeBot(text, bilder, von, name) {
  const mensch = von === 'mitarbeiter', m = el('div', { class: mensch ? 'm mensch' : 'm' }), r = [];
  if (mensch || mitMensch) m.append(el('div', { class: 'von', text: absenderText(von, name) }));
  for (const b of bloecke(text)) {
    const x = b.typ === 'liste' ? b.punkte.map(p => zeileK(el('li'), p, r)).filter(Boolean) : [zeileK(el('p'), b.text, r)];
    if (x[0]) m.append(b.typ === 'liste' ? el('ul', {}, ...x) : x[0]);
  }
  for (const x of bilder || []) {
    if (x.nur && HQ.matches) continue;   // nur PC-Bild
    const b = x.handy && HQ.matches ? { ...x, ...x.handy } : x;
    const src = API + '/bild/' + b.id, a = el('a', { class: x.art ? 'bild hilfe' : 'bild', href: src, ...NEU },
      el('img', { crossorigin: 'anonymous', src, alt: b.alt, width: b.b, height: b.h, loading: 'lazy', decoding: 'async', referrerpolicy: 'no-referrer', onerror: () => a.remove() }));
    m.append(a);
  }
  if (r[0]) m.append(el('div', { class: 'chips eins' }, ...r.map(h => knopf(h, 'chip'))));
  zeige(m);
}
function zeigeHinweis(text) { zeige(zeileIn(el('p', { class: 'h' }), text)); }
function zeigeFehler(text, nachricht) {
  const d = zuletzt, knopf = el('button', { class: 'nochmal', text: 'Erneut senden', onclick: () => {
    if (d && (d.bild || d.tasse)) { if (!wartet && !gesperrt) post(d, nachricht); } else schicke(nachricht);
    fokus(feld);
  } });
  zeige(fehlerBox = el('div', { class: 'f' }, el('p', {}, text, el('a', { href: WA, ...NEU, text: 'WhatsApp' }), '.'), knopf));
}
function zeigeNachricht(n) {
  gesehen.add(n.seq);
  if (n.von === 'system') return zeigeHinweis(n.text);
  if (n.von === 'mitarbeiter' && (mitMensch = 1) && !offen) zaehle(ungelesen + 1);
  zeigeBot(n.text, n.bilder, n.von, n.name);
}
function zaehle(n) {
  const t = n ? n + ' neue Nachricht' + (n > 1 ? 'en' : '') + ' vom Team' : '';
  rot.textContent = n > 9 ? '9+' : n;
  rot.hidden = !(ungelesen = n);
  start.setAttribute('aria-label', offen ? 'Chat schließen' : T.auf + (t ? ' – ' + t : T.on));
  ansage.textContent = t;
}

function zustand(d) {
  if (typeof d.takt === 'number') takt = d.takt;
  if (d.modus !== 'ki' && d.modus !== 'mensch') return;
  const m = d.modus === 'mensch', wechsel = modus !== d.modus, wer = m ? absenderText('mitarbeiter', d.mitarbeiter) : T.titel;
  modus = d.modus;
  if (neuK) neuK.hidden = m;
  if (wechsel) speicherSchreiben();
  titel.textContent = wer;
  unter.textContent = m ? T.mensch : unterKi;
  fenster.setAttribute('aria-label', wer);
  if (m) {
    mitMensch = 1;
    tipp.remove();
    if (wechsel && gesperrt === 'limit') freigeben();
  }
}

function sperre(text, grund) {
  if (gesperrt) return;
  gesperrt = grund || 'aus';
  wrap.classList.add('gesperrt');
  if (gesperrt == 'aus') { wrap.classList.add('still'); T.on = ''; zaehle(ungelesen); speicherWeg(); }   // Knopf ohne „online“
  const fokusWeg = root.activeElement === feld;
  if (text) zeigeHinweis(text);
  zeige(sperrKnopf = waKnopf());
  feld.disabled = senden.disabled = anh.disabled = true;
  feld.placeholder = 'Weiter per WhatsApp';
  if (fokusWeg) fokus(sperrKnopf);
}
function freigeben() {
  const f = root.activeElement === sperrKnopf;
  gesperrt = false;
  wrap.classList.remove('gesperrt');
  sperrKnopf.remove();
  feld.disabled = false;
  feld.placeholder = T.platz;
  eingabe();
  if (f) fokus(feld);
}

function setzeWarten(an) {
  wartet = an;
  if (an && modus !== 'mensch') zeige(tipp); else tipp.remove();
  eingabe();
}

function eingabe() {
  const n = feld.value.length;
  feld.style.height = 'auto';
  feld.style.height = Math.min(feld.scrollHeight, 132) + 'px';
  feld.style.overflowY = feld.scrollHeight > 132 ? 'auto' : 'hidden';
  zahl.hidden = n < ZAEHLER_AB;
  zahl.textContent = n + ' / ' + MAX;
  senden.disabled = wartet || gesperrt || !feld.value.trim() && !bild;
  anh.disabled = wartet || !!gesperrt;
}

function waehle() {
  const f = datei.files && datei.files[0];
  datei.value = '';
  if (f) nimm(f);
}
function nimm(f) {
  const g = pruefeDatei(f);
  if (g && !(g !== 'format' && window.createImageBitmap)) return zeigeHinweis(T[g]);
  if (bilderN >= BILD_JE) return zeigeHinweis(T.voll);
  let u = '';
  try { u = URL.createObjectURL(f); } catch (e) {}
  if (bild) wegUrl(bild.u);
  bild = { f, u };
  vor.textContent = '';
  vor.append(u ? el('img', { src: u, alt: 'Ausgewähltes Bild' }) : '📷',
    el('button', { 'aria-label': 'Bild entfernen', onclick: () => { bildWeg(); fokus(feld); } }, icon(18, I_ZU, 2.4)));
  vor.hidden = false;
  if (!bildHinweis++) zeigeHinweis(T.bildDaten);
  eingabe();
  fokus(feld);
}
function wegUrl(u) { if (u) URL.revokeObjectURL(u); }
function bildWeg(mit) { if (bild && !mit) wegUrl(bild.u); bild = null; vor.hidden = true; vor.textContent = ''; eingabe(); }

// verkleinern (EXIF bleibt hier)
async function verkleinern(f) {
  if (f.size < 1.5e6 && /png|webp/.test(f.type) || !window.createImageBitmap) return f;
  try {
    const b = await createImageBitmap(f), s = Math.min(1, 2048 / Math.max(b.width, b.height)), c = document.createElement('canvas'), g = c.getContext('2d');
    c.width = Math.round(b.width * s); c.height = Math.round(b.height * s);
    g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
    g.drawImage(b, 0, 0, c.width, c.height);
    const j = await new Promise(r => c.toBlob(r, 'image/jpeg', .85));
    return j && (j.size < f.size || pruefeDatei(f)) ? j : f;
  } catch (e) { return f; }
}
function hochladen(f, fort) {
  return new Promise((ok, nein) => {
    const x = new XMLHttpRequest();
    x.open('POST', API + '/kundenbild');
    x.timeout = 90000;
    x.setRequestHeader('Content-Type', f.type || 'application/octet-stream');
    x.upload.onprogress = e => e.lengthComputable && fort(Math.round(e.loaded / e.total * 100));
    x.onload = () => { try { ok(JSON.parse(x.responseText)); } catch (e) { nein(e); } };
    x.onerror = x.ontimeout = x.onabort = nein;
    x.send(f);
  });
}
async function mitBild(b, text, st) {
  bildWeg(1);
  setzeWarten(true);
  let d = null;
  try {
    const f = await verkleinern(b.f);
    d = pruefeDatei(f) ? { antwort: T[pruefeDatei(f)] } : await hochladen(f, p => { st.textContent = T.lade + p + ' %'; });
  } catch (e) {}
  if (!d || d.status !== 'ok' || typeof d.bild !== 'string') {
    setzeWarten(false);
    st.textContent = '';
    zeileIn(st, d && typeof d.antwort === 'string' ? d.antwort.slice(0, 300) : T.bildFehler);
    if (d && d.status === 'aus') anh.hidden = true;
    return;
  }
  st.remove();
  if (++bilderN >= BILD_JE) anh.hidden = true;
  post({ nachricht: text, bild: d.bild }, text || '📷');
}

function anfrage(pfad, koerper, ms) {
  const ctl = new AbortController(), uhr = setTimeout(() => ctl.abort(), ms);
  const opt = { method: koerper ? 'POST' : 'GET', credentials: 'omit', cache: 'no-store', referrerPolicy: 'strict-origin', signal: ctl.signal };
  if (koerper) { opt.headers = { 'Content-Type': 'application/json' }; opt.body = JSON.stringify(koerper); }
  return fetch(API + pfad, opt).then(r => r.json()).finally(() => clearTimeout(uhr));
}

function schicke(nochmal, chipText, extra) {
  const neu = typeof nochmal !== 'string', text = chipText || (neu ? feld.value.trim() : nochmal), b = neu && !chipText && bild;
  if (wartet || gesperrt || !text && !b || text.length > MAX) return;
  if (fehlerBox) { fehlerBox.remove(); fehlerBox = null; }
  const st = b && el('p', { class: 'bs', role: 'status', text: T.lade });
  if (neu) {
    zeige(b ? el('div', { class: 'm du' }, b.u ? el('img', { src: b.u, alt: 'Dein Bild', onload: () => wegUrl(b.u) }) : null, text ? el('p', { text }) : null, st) : el('div', { class: 'm du', text }));
    if (!chipText) feld.value = '';
  }
  if (!API) return sperre(T.aus);
  if (b) return mitBild(b, text, st);
  post({ nachricht: text, ...extra }, text);
}
function post(daten, text) {
  if (fehlerBox) { fehlerBox.remove(); fehlerBox = null; }
  zuletzt = daten;
  setzeWarten(true);
  anfrage('/chat', { gespraech, v: 4, ...daten, ...bruecke() && { k: true }, ...T1 && { t: true }, ...gp(daten) }, 45000).then(d => verarbeite(d, text), () => verarbeite(null, text)).finally(() => planeAbfrage(1));
}

function verarbeite(d, text) {
  setzeWarten(false);
  const ok = !!d && typeof d === 'object', st = ok && d.status;
  if (text === '' && !/^(ok|mensch|aus)$/.test(st) && ++nachFehl < 3) nachgeholt = 0;
  const hinweis = ok && typeof d.hinweis === 'string' ? d.hinweis.trim().slice(0, 300) : '';
  if (ok && typeof d.gespraech === 'string' && /^[\w-]{16,64}$/.test(d.gespraech) && d.gespraech !== gespraech) {
    if (gespraech) bilderN = 0;
    gespraech = d.gespraech;
    seqMax = 0; gesehen.clear();
    speicherWeg();
  }
  if (ok) speicherSchreiben(FORT.test(d.fort) && d.fort);
  const seq = ok && Number.isInteger(d.seq) && d.seq > 0 ? d.seq : 0, schonDa = gesehen.has(seq);
  if (ok) zustand(d);
  const v = ok && d.system;
  if (v && v.seq > 0 && typeof v.text == 'string' && !gesehen.has(v.seq)) { gesehen.add(v.seq); zeigeHinweis(v.text.slice(0, 500)); }
  if (ok && typeof d.ref === 'string' && /^[a-z2-7]{20}$/.test(d.ref) && d.ref !== markiert) merke(d.ref);
  if (seq) {
    if (text && seq === seqMax + (st === 'mensch' ? 1 : 2)) seqMax = seq;   // lückenlos (Vertrag 5.2)
    gesehen.add(seq);
  }
  if (st === 'ok' && typeof d.antwort === 'string' && d.antwort.trim()) {
    if (!schonDa) zeigeBot(d.antwort.slice(0, 4000), bilderPruefen(d.bilder));
    if (d.aktion === 'bestellstatus') formular();
    else if (d.aktion === 'rueckmeldung') rueckForm();
    else if (d.aktion === 'link_zur_tasse') linkKarte();
    else if (d.aktion === 'link_knopf') linkChip('🔗 Link zu meiner Tasse');
    else if (d.aktion === 'dup_seite') schonDa || dupKarte();
    else if (d.aktion === 'tasse_knopf') tChip && tChip !== 1 ? zeige(tChip) : (tChip = 0, tasseChip());
    if (d.rest === 0) return sperre(hinweis || T.limit, 'limit');
  } else if (st === 'aus' || st === 'limit' && !(d.rest > 0)) return sperre(T[st], st);
  else if (st !== 'mensch' && text) return zeigeFehler(st === 'limit' ? T.viel : T.fehler, text);
  if (hinweis) zeigeHinweis(hinweis);
}

function holeStatus() {
  anfrage('/status', null, 8000).then(d => {
    if (!d || typeof d.aktiv !== 'boolean') return;
    if (d.testmodus === true) unter.textContent = unterKi = T.unter + ' · Testmodus';
    anh.hidden = !(d.aktiv && d.bilder === true) || bilderN >= BILD_JE;
    hilfe(d.hilfe, d.bilder);
    if (!d.aktiv && !gespraech) sperre(T.aus);
    else if (d.aktiv && !chips) zeige(chips = el('div', { class: 'chips', role: 'group', 'aria-label': 'Schnellwahl' },
      ...CHIPS.concat(d.bestellstatus === true ? T.bs : []).map(t => el('button', { class: 'chip', text: t,
        onclick: () => { if (!wartet && !gesperrt) { chips.remove(); t == CHIPS[2] ? vorlagen() : (schicke(0, t), fokusEin()); } } }))));
    tasseAn = d.aktiv && (d.tasse === true || d.tasse === 'test' && T1);
    tasseChip();
  }, () => {});
}

const T1 = /[?&]txchat=1\b/.test(location.search) || !!merk && merk.t === 1, an = x => x === true || x === 'test' && T1;
function hilfe(h, b) {   // fehlt = aus
  const k = !!h && an(h.knoepfe), g = !!h && an(h.gestaltung);
  HILFE = { k, nl: k && typeof h.nl_formular == 'string' && /^[A-Za-z0-9]{6}$/.test(h.nl_formular) ? h.nl_formular : '', g, gb: g && b && an(h.gestaltung_bild) };
}
function bruecke() {   // Kunde gestaltet
  try { const c = window.TasseKonfigurator.chat; return vd && c.version === 1 && c.bereit() === true && c; } catch (e) {}
}
async function holeTasse(e) {
  let r, c = bruecke();
  setzeWarten(true);
  try { if (e) e.z = c.zusammenfassung(); r = await Promise.race([c.meinLink(), new Promise(ok => setTimeout(ok, 25e3))]); } catch (x) {}
  setzeWarten(false);
  planeAbfrage();
  const l = r && r.ok === true && typeof r.link == 'string' && TL.test(r.link) ? r.link : '', f = !l && r && /^(zu|leer|pruefen|netz)$/.test(r.fehler) ? r.fehler : '',
    t = r && typeof r.text == 'string' && r.text.trim();
  if (e) e.f = f;   // Konfigurator-Satz nur bei leer/pruefen
  if (!l) zeigeHinweis(t && /^(leer|pruefen)$/.test(f) ? T.fast + t.slice(0, 200) : T[f] || T.tf);
  return l;
}
async function linkKarte() {   // (b) Link bleibt im Browser
  const l = await holeTasse(), w = 'Meine Tasse – hier geht es weiter:', f = el('input', { readonly: true, value: l, 'aria-label': 'Dein Link', onfocus: () => f.select() }),
    k = el('button', { class: 'chip', text: '📋 Kopieren', onclick: () => (navigator.clipboard ? navigator.clipboard.writeText(l) : Promise.reject()).then(() => { k.textContent = 'Kopiert ✓'; },
      () => { fokus(f); f.select(); k.textContent = 'Markiert – jetzt kopieren'; }) });
  if (!l) return linkChip('🔄 Nochmal');
  zeige(el('div', { class: 'm karte' }, el('p', { class: 'ds', text: '🔗 Dein Link zur Tasse' }), f, el('div', { class: 'chips eins' },
    el('a', { class: 'chip', href: 'https://wa.me/?text=' + encodeURIComponent(w + ' ' + l), ...NEU, text: '💬 Per WhatsApp an mich' }),
    el('a', { class: 'chip', href: 'mailto:?subject=' + encodeURIComponent('Meine Tasse – am PC weitermachen') + '&body=' + encodeURIComponent(w + '\n\n' + l), text: '📧 Per E-Mail an mich' }), k)));
}
function linkChip(t) {
  const x = el('div', { class: 'chips eins' }, el('button', { class: 'chip', text: t, onclick: () => { if (!wartet) { x.remove(); fokusEin(); linkKarte(); } } }));
  zeige(x);
}
function tasseChip() {   // (c) erst der Klick schickt
  if (tChip && tChip !== 1) tChip.hidden = !bruecke();
  else if (tasseAn && !tChip && !gesperrt && bruecke()) zeige(tChip = el('div', { class: 'chips eins' }, el('button', { class: 'chip', text: T.tasse, onclick: hilfeTasse }),
    el('p', { class: 'ds', text: HILFE.g ? 'schickt dem Team den Link und dem KI-Assistenten Lage, Größe und Auflösung' + (HILFE.gb ? ' und beiden eine Ansicht' : '') : T.tz })));
}
async function hilfeTasse() {   // ohne Link: Grund
  if (wartet || gesperrt) return;
  const e = {}, z = GZ, l = await holeTasse(e);
  if (z != GZ) return;
  if (l) { tChip.remove(); tChip = 1; }
  if (l || e.f != 'zu') {
    if (HILFE.g) GS = 1;
    const a = GS && HILFE.gb && bilderN < BILD_JE - 1 && await ansicht();
    z == GZ && schicke(0, T.tasse, { tasse: tassePaket(l, e.z, e.f), ...a });
  }
}
async function ansicht(r, s, z = GZ) {   // Stufe B: je Stand einmal
  setzeWarten(true);
  try {
    const b = (s = bruecke().gestaltung().stand) != GB && await sa('gestaltung_bild') && await Promise.race([bruecke().ansicht(), new Promise(ok => setTimeout(ok, 9e3))]),
      d = z == GZ && b.type == 'image/jpeg' && b.size <= 4e5 && await hochladen(b, () => {});
    if (z == GZ && d.status == 'ok' && typeof d.bild == 'string') r = { bild: d.bild, gestaltung_bild: true }, GB = s, ++bilderN < BILD_JE || (anh.hidden = true);
  } catch (x) {}
  setzeWarten(false);
  return r;
}
const sa = n => anfrage('/status', null, 8e3).then(d => d.aktiv && an(d.hilfe[n])).catch(() => 0);
// Zahlen nach 🧩: nur GK, ≤ 3000 B, Body < 7.500 B
const GK = 'stand,g,el,hg,nm,mehr,n,a,i,s,x,y,b,h,r,dpi,q,d,vk,f,fs,k,rn'.split(','), u8 = s => encodeURIComponent(s).replace(/%../g, 1).length;
function gp(d) {
  try {
    const g = GS && HILFE.g && !d.nachholen && bruecke().gestaltung(), s = g && JSON.stringify(g, GK);
    if (s && u8(s) <= 3e3 && u8(JSON.stringify(d)) + u8(s) < 7400) return { gestaltung: JSON.parse(s) };
  } catch (e) {}
}
// Knöpfe aus kopie; Klick → /status → tue
function dupKarte() {
  let g, x;
  const c = bruecke(), satz = f => zeigeHinweis(f == 'zu' ? T.zu : (DG[f] || 'Das geht gerade nicht+').replace('+', ' – wähl es aus und tipp auf „Duplizieren“ 👍')),
    mach = async (f, dann) => {
      if (dupL || wartet) return;
      dupL = 1; x.remove();
      let r, c = bruecke(), ok = await sa('aktionen');
      if (ok && c) try { r = await f(c); } catch (e) {}
      dupL = 0;
      ok ? dann(r, c) : melde('aktion_aus') || zeigeHinweis('Das geht gerade nicht 🙈');
    },
    kn = (text, onclick) => el('button', { class: 'chip', text, onclick });
  try { g = c.gestaltung(); } catch (e) {}
  const l = (g && Array.isArray(g.kopie) ? g.kopie : []).filter(k => k && AN[k.a] && SL[k.von] && SL[k.nach] && [k.n, k.i].every(v => (v | 0) === v && v > 0 && v < 21)).slice(0, 3);
  if (!l[0]) return satz(c ? g && g.grund : 'zu');
  zeige(x = el('div', { class: 'chips eins' }, ...l.map(k => kn(AN[k.a] + ' ' + k.i + ' · ' + SL[k.von] + ' → ' + SL[k.nach], () => mach(c => c.tue({ art: 'dup_seite', n: k.n, stand: g.stand }), (r, c) => {
    if (!r || r.ok !== true) return melde('aktion_fehler'), satz(c ? r && r.fehler : 'zu');
    melde('aktion_ok');
    dupZ && dupZ.remove();
    const w = dupZ = kn('↩️ Rückgängig', () => mach(c => c.zurueck(), (q, c) => {
      w.remove(); dupZ = 0;
      q && q.ok === true ? (melde('aktion_zurueck'), zeigeHinweis('↩️ Kopie entfernt.')) : satz(c ? 'weg' : 'zu');
    }));
    zeige(el('div', { class: 'm karte' }, el('p', { text: '✅ ' + AN[k.a] + ' ' + k.i + ' steht jetzt auch ' + SL[k.nach] + '.' + (r.rand ? ' ⚠️ Nah am Rand.' : '') }),
      el('div', { class: 'chips eins' }, w, kn('👀 Ansehen', schliessen))));
  }))), kn('Nein danke', () => { x.remove(); fokusEin(); })));
}

// 🎨: ohne KI; gezählt nur die Wahl (ohne Gesprächs-ID)
function melde(art) {
  if (API) fetch(API + '/ereignis', { method: 'POST', keepalive: true, credentials: 'omit', referrerPolicy: 'strict-origin',
    headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ art }) }).catch(() => {});
}
function vorlagen() {   // je Karte einmal gezählt
  let k, a, v;
  zeige(el('div', { class: 'm du', text: CHIPS[2] }));
  zeige(el('div', { class: 'm karte' }, el('p', { text: 'Was möchtest du? 🎨' }), el('div', { class: 'chips eins' },
    a = el('a', { class: 'chip', href: '/products/tassen-mit-logo-bedrucken-keramik#vorlagen', rel: 'noopener', text: '✨ Zu den Vorlagen', onclick: e => {
      const g = document.querySelector('te-template-gallery#vorlagen');
      v || melde(v = 'vorlagen');
      a.setAttribute('target', vd ? '_blank' : '_self');   // Konfigurator: neuer Tab
      if (vd || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      schliessen();
      if (g) {   // Galerie auf dieser Seite: nur scrollen
        e.preventDefault();
        g.scrollIntoView({ block: 'start', behavior: RUHIG.matches ? 'auto' : 'smooth' });
        g.hasAttribute('tabindex') || g.setAttribute('tabindex', -1);
        fokus(g);
      }
    } }),
    el('button', { class: 'chip', text: '📄 Druckvorlage herunterladen', onclick: () => {
      k || melde('druckvorlage');
      zeige(k = k || el('a', { class: 'm karte dv', href: '/apps/tasse/druckvorlage?quelle=chat', download: 'TassenExpress-Vorlage.pdf',
        'aria-label': 'Druckvorlage herunterladen (PDF)' }, el('span', { class: 'senden' }, icon(24, I_DL, 2.3)),
        el('p', {}, 'Druckvorlage', el('span', { class: 'ds', text: 'PDF · 1,5 MB' }))));
      fokus(k);
    } }))));
  fokus(a);
}

// Bestellstatus: nie in den Chat
function formular() {
  if (karte) karte.remove();
  const nr = el('input', { inputmode: 'numeric', autocomplete: 'off', maxlength: 12, placeholder: 'z. B. 1234' }),
    mail = el('input', { type: 'email', autocomplete: 'off', maxlength: 254, spellcheck: 'false', placeholder: 'name@firma.de' }),
    knopf = el('button', { class: 'pruefen', type: 'submit', text: 'Status prüfen' }), info = el('p', { class: 'h', role: 'status' }),
    frei = an => { nr.disabled = mail.disabled = knopf.disabled = !an; };
  const f = karte = el('form', { class: 'm karte', 'aria-label': 'Bestellstatus', novalidate: true, onsubmit: e => {
    e.preventDefault();
    const n = nr.value.replace(/\s/g, ''), m = mail.value.trim();
    if (!/^#?\d{3,8}$/.test(n) || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(m)) { info.textContent = T.bsFalsch; return fokus(nr); }
    frei(0);
    info.textContent = 'Ich schaue nach …';
    anfrage('/bestellstatus', { gespraech, bestellnummer: n, email: m }, 20000).then(d => d, () => null).then(d => {
      const b = d && d.bestellung, txt = s => typeof s === 'string' ? s.slice(0, 80) : '';
      if (d && Number.isInteger(d.seq) && d.seq > 0) gesehen.add(d.seq);   // Systemzeile 1×
      if (d && d.status === 'ok' && b && txt(b.titel)) {
        const link = dhlLink(b.link), j = STUFE[b.art], z = b.art === 'zugestellt';
        f.remove();
        return zeige(el('div', { class: 'm karte' }, el('div', { class: 'status' },
          el('div', { class: 'sk' }, el('div', { class: 'von', text: 'Bestellung #' + n.replace('#', '') }),
            el('p', { class: 'gross' }, el('span', { class: 'si', 'aria-hidden': 'true', text: z ? '🚚' : txt(b.emoji).slice(0, 4) || '📦' }), ' ' + (z ? 'Versendet' : txt(b.titel))),
            !z && txt(b.zeile) ? el('p', { text: txt(b.zeile) }) : null,
            link && el('a', { href: link, ...NEU, rel: 'noopener noreferrer nofollow', text: 'Sendung verfolgen ↗' })),
          j >= 0 ? el('ol', { class: 'st', 'aria-label': 'Fortschritt' }, ...STUFEN.map((s, i) => el('li', i < j ? { class: 'ok' } : i > j ? {} : { class: 'jetzt', 'aria-current': 'step' },
            el('i'), s, i < j ? el('span', { class: 'sr', text: ' (erledigt)' }) : null))) : null)));
      }
      if (d && d.status === 'aus') { f.remove(); return zeigeHinweis(txt(d.antwort) ? d.antwort.slice(0, 300) : T.aus); }
      frei(1);
      info.textContent = '';
      zeileIn(info, d && typeof d.antwort === 'string' ? d.antwort.slice(0, 300) : T.fehler + WA);
    });
  } }, el('label', {}, 'Bestellnummer', nr), el('label', {}, 'E-Mail aus der Bestellung', mail), knopf, info);
  zeige(f);
  if (FEIN.matches) fokus(nr);
}

// Kauf nach Chat: Referenz
function merke(r) {
  markiert = r;
  fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { _txchat: r } }) }).catch(() => {});
}

// Rückmeldung: E-Mail nie in den Chat
function rueckForm() {
  if (karte) karte.remove();
  const mail = el('input', { type: 'email', autocomplete: 'email', maxlength: 254, spellcheck: 'false', placeholder: 'name@firma.de' }),
    knopf = el('button', { class: 'pruefen', type: 'submit', text: 'Senden' }), info = el('p', { class: 'h', role: 'status' });
  const f = karte = el('form', { class: 'm karte', 'aria-label': 'E-Mail für Rückmeldung', novalidate: true, onsubmit: e => {
    e.preventDefault();
    const m = mail.value.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(m)) { info.textContent = T.rmFalsch; return fokus(mail); }
    mail.disabled = knopf.disabled = true;
    anfrage('/rueckmeldung', { gespraech, email: m }, 15000).then(d => d, () => null).then(d => {
      const ok = d && /^(ok|geaendert)$/.test(d.status), t = d && typeof d.antwort === 'string' ? d.antwort.slice(0, 300) : '';
      if (ok && Number.isInteger(d.seq) && d.seq > 0) gesehen.add(d.seq);
      if (ok || d && d.status === 'aus') { f.remove(); return zeigeHinweis(t || T.aus); }
      mail.disabled = knopf.disabled = false;
      info.textContent = '';
      zeileIn(info, t || T.fehler + WA);
    });
  } }, el('p', { class: 'von', text: T.rm }), el('label', {}, 'Deine E-Mail', mail), knopf, el('p', { class: 'h', text: T.rmInfo }), info);
  zeige(f);
}

// Abfrage /neu: setTimeout-Kette (Vertrag 5.3)
function planeAbfrage(sofort) {
  clearTimeout(uhr);
  if (sofort) fehlerN = 0;
  const s = naechsterTakt(takt, modus, offen, fehlerN);
  if (gespraech && !document.hidden && !wartet && (s || sofort && offen)) uhr = setTimeout(frage, sofort ? 0 : s * 1000);
}
function frage() {
  const g = gespraech;
  if (!wartet) anfrage('/neu', { gespraech: g, ab: seqMax }, 10000).then(d => g === gespraech && neu(d))
    .then(w => (fehlerN = 0, w), () => { fehlerN++; }).then(planeAbfrage);
}
function neu(d) {
  if (d.status !== 'ok') return zustand({ takt: d.takt }), false;
  zustand(d);
  const r = neueNachrichten(d, seqMax, gesehen);
  seqMax = r.seqMax;
  r.liste.forEach(zeigeNachricht);
  if (d.nachholen !== true) nachgeholt = nachFehl = 0;
  else if (!nachgeholt && !wartet) {
    nachgeholt = 1;
    post({ nachricht: '', nachholen: true }, '');
  }
  return r.mehr;
}

// Verlauf (V-H1 10): nur Tab-Speicher „txc“, nie ID/Text
function speicherLesen() {
  try {
    const r = sessionStorage.getItem('txc'), e = r && JSON.parse(r);
    if (e && FORT.test(e.f) && /^(ki|mensch)$/.test(e.m) && Date.now() - e.z < 864e5) return e;
    if (r) speicherWeg();
  } catch (x) {}
  return null;
}
function speicherSchreiben(f) {   // ohne f: nur m/z
  try { if (f = f || (speicherLesen() || {}).f) sessionStorage.setItem('txc', JSON.stringify({ f, m: modus, z: geschrieben = Date.now(), ...T1 && { t: 1 } })); } catch (x) {}
}
function speicherWeg() { try { sessionStorage.removeItem('txc'); } catch (x) {} }

function verlauf(nochmal) {
  setzeWarten(true);
  anfrage('/verlauf', { fort: merk.f, v: 3, ...T1 && { t: true } }, 10000).then(d => d, () => 0).then(d => {
    const st = d && d.status;
    if (st == 'langsam' && !nochmal) return setTimeout(() => verlauf(1), (d.takt > 0 && d.takt < 60 ? d.takt : 15) * 1000);
    setzeWarten(false);
    if (st == 'ok' && /^[\w-]{16,64}$/.test(d.gespraech) && FORT.test(d.fort)) return wiederher(d);
    if (d || nochmal) speicherWeg();
    merk = null;
    if (offen) hallo(); else begruesst = false;
  });
}
function wiederher(d) {
  merk = null;
  hilfe(d.hilfe);
  gespraech = d.gespraech; seqMax = 0; gesehen.clear();
  bilderN = Math.max(0, d.bilder_n | 0);
  if (d.mehr === true) zeigeHinweis(T.aelter);
  for (const n of Array.isArray(d.nachrichten) ? d.nachrichten : []) {
    const t = n && typeof n.text == 'string' && n.text.trim() ? n.text : '', v = n && n.von, b = n && n.kundenbild === true;
    if (!(n && n.seq > seqMax && Number.isInteger(n.seq))) continue;
    gesehen.add(seqMax = n.seq);
    if (v == 'kunde' && (b || t)) zeige(el('div', { class: 'm du', text: (b ? '📷 Bild' + (t && '\n') : '') + t.slice(0, 1000) }));
    else if (v == 'system' && t) zeigeHinweis(t.slice(0, 500));
    else if ((v == 'ki' || v == 'mitarbeiter') && t) { zeigeBot(t.slice(0, 4000), bilderPruefen(v == 'ki' && n.bilder), v, n.name); mitMensch |= v == 'mitarbeiter'; }
  }
  if (d.seq > seqMax && Number.isInteger(d.seq)) seqMax = d.seq;
  zustand(d);
  zeige(el('p', { class: 'h' }, T.vorhin, neuK = el('button', { text: T.neuG, hidden: modus == 'mensch', onclick: neuesGespraech })));
  speicherSchreiben(d.fort);
  chips = chips || 1;   // keine Schnellwahl
  holeStatus();
  if (d.rest === 0) sperre(T.limit, 'limit');
  planeAbfrage();
}
function neuesGespraech() {   // nicht mit Mitarbeiter
  const e = speicherLesen();
  if (wartet || modus == 'mensch') return;
  if (e) anfrage('/verlauf', { fort: e.f, vergessen: true }, 8000).catch(() => {});
  speicherWeg(); leeren(); hallo(); fokusEin();
}
function leeren() {
  clearTimeout(uhr);
  log.textContent = '';
  gespraech = chips = tChip = fehlerBox = karte = neuK = null;
  seqMax = mitMensch = bilderN = takt = GB = 0;
  gesehen.clear(); zustand({ modus: modus = 'ki' }); zaehle(0);
  if (gesperrt == 'limit') freigeben();
}
// bfcache: 🧩 neu tippen; Stand der neueren Seite
addEventListener('pageshow', e => {
  if (!e.persisted) return;
  GS = GB = 0; GZ++;
  if (tChip === 1) tChip = 0, tasseChip();
  if (zuletzt && zuletzt.tasse) zuletzt = 0, fehlerBox && fehlerBox.remove();
  if (!API || wartet || gesperrt) return;
  const s = speicherLesen();
  if (s ? s.z <= geschrieben : !geschrieben) return;
  leeren();
  merk = s;
  if (begruesst = offen || !!s && s.m == 'mensch') s ? verlauf() : hallo();
});

function masse() {
  ku = kopf.offsetTop + kopf.offsetHeight;
  fh = fuss.offsetHeight;
  const s = fenster.style;
  s.setProperty('--ku', ku + 'px');
  s.setProperty('--fh', fh + 'px');
}
const RO = window.ResizeObserver && new ResizeObserver(() => {
  const ende = amEnde;
  masse();
  if (ende) zumEnde();
  linsePlanen();
});
if (RO) for (const x of [kopf, fuss, fenster, start]) RO.observe(x);

let lx = 0, ly = 0, lf = 0;
function licht() {
  lf = 0;
  for (const x of offen ? [fenster, start] : [start]) {
    const r = x.getBoundingClientRect(), s = x.style, p = (v, a, b) => Math.min(115, Math.max(-15, (v - a) / b * 100)).toFixed(1) + '%';
    if (!r.width) continue;
    s.setProperty('--lx', p(lx, r.left, r.width));
    s.setProperty('--ly', p(ly, r.top, r.height));
    s.setProperty('--la', (Math.atan2(r.left + r.width / 2 - lx, ly - r.top - r.height / 2) * 180 / Math.PI).toFixed(1) + 'deg');
  }
}

// Lichtbrechung nur Chromium; Randkarte: R/G biegen, B = Maske
let LINSE = false, lp, ls, linseUhr = 0;
try { LINSE = navigator.userAgentData.brands.some(b => /Chrom|Edge/.test(b.brand)) && window.CSS.supports('backdrop-filter', 'url(#a) blur(1px)'); } catch (e) {}
if (LINSE) {
  const bild = () => el('feImage', { x: 0, y: 0, width: 1, height: 1, preserveAspectRatio: 'none', result: 'k' }),
    versatz = r => el('feDisplacementMap', { in: 'SourceGraphic', in2: 'k', scale: 0, xChannelSelector: 'R', yChannelSelector: 'G', result: r }),
    filter = (id, ...k) => el('filter', { id, x: 0, y: 0, width: '100%', height: '100%', 'color-interpolation-filters': 'sRGB' }, ...k),
    weich = (i, s, r) => el('feGaussianBlur', { in: i, stdDeviation: s, edgeMode: 'duplicate', result: r });
  lp = { b: bild(), v: versatz('g') };
  ls = { b: bild(), v: versatz() };
  wrap.append(el('svg', { class: 'defs', 'aria-hidden': 'true' },
    filter('txc-lp', lp.b, weich('SourceGraphic', 16, 'm'), lp.v, weich('g', 2.5, 'w'),
      el('feColorMatrix', { in: 'k', type: 'matrix', values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0 0', result: 'r' }),
      el('feComposite', { in: 'w', in2: 'r', operator: 'in', result: 'x' }),
      el('feMerge', {}, el('feMergeNode', { in: 'm' }), el('feMergeNode', { in: 'x' }))),
    filter('txc-ls', ls.b, ls.v)));
}
function randKarte(w, h, r, band) {
  const c = document.createElement('canvas'), hw = w / 2, hh = h / 2;
  c.width = w; c.height = h;
  const g = c.getContext('2d'), bild = g.createImageData(w, h), d = bild.data;
  r = Math.min(r, hw, hh);
  for (let y = 0, i = 0; y < h; y++) {
    const py = y + .5 - hh, qy = Math.abs(py) - hh + r;
    for (let x = 0; x < w; x++, i += 4) {
      const px = x + .5 - hw, qx = Math.abs(px) - hw + r;
      let a, nx = 0, ny = 0;
      if (qx > 0 && qy > 0) { const l = Math.hypot(qx, qy); a = r - l; nx = Math.sign(px) * qx / l; ny = Math.sign(py) * qy / l; }
      else if (qx > qy) { a = r - qx; nx = Math.sign(px); }
      else { a = r - qy; ny = Math.sign(py); }
      const t = a < band ? 1 - Math.max(0, a) / band : 0, q = t * t;
      d[i] = 128 - nx * q * 127; d[i + 1] = 128 - ny * q * 127; d[i + 2] = 255 * q * (3 - 2 * t); d[i + 3] = 255;
    }
  }
  g.putImageData(bild, 0, 0);
  return c.toDataURL();
}
async function linse(t, x, r, band, staerke) {
  const w = x.offsetWidth, h = x.offsetHeight, key = w + 'x' + h;
  if (!w || !h) return false;
  if (t.key === key) return true;
  t.key = key;
  const url = randKarte(w, h, r, band), probe = new Image();
  probe.src = url;
  try { await probe.decode(); } catch (e) { LINSE = false; return false; }
  if (t.key !== key) return false;
  t.b.setAttribute('width', w); t.b.setAttribute('height', h); t.b.setAttribute('href', url);
  t.v.setAttribute('scale', staerke);
  return true;
}
function linsePlanen() { if (LINSE) { clearTimeout(linseUhr); linseUhr = setTimeout(linsen, 120); } }
async function linsen() {
  const an = LINSE && !WENIG.matches,
    [a, b] = an ? await Promise.all([(offen || lp.key) && !MQ.matches && linse(lp, fenster, 34, 28, 40), linse(ls, start, 22, 22, 44)]) : [];
  wrap.classList.toggle('rp', !!a && LINSE);
  wrap.classList.toggle('rs', !!b && LINSE);
}

feld.addEventListener('input', eingabe);
// Handy: Tastatur auf → letzte Nachricht
feld.addEventListener('focus', () => { if (modal) for (const t of [0, 150, 400, 700]) setTimeout(zumEnde, t); });
log.addEventListener('scroll', () => { amEnde = log.scrollHeight - log.scrollTop - log.clientHeight < 48; }, { passive: true });
// Datei aufs Fenster → Anhang
for (const t of ['dragenter', 'dragover', 'drop']) fenster.addEventListener(t, e => {
  const d = e.dataTransfer;
  if (!d || !Array.from(d.types || []).includes('Files')) return;
  e.preventDefault();
  if (t === 'drop' && d.files[0] && !anh.disabled && (!anh.hidden || bilderN >= BILD_JE)) nimm(d.files[0]);
});
feld.addEventListener('keydown', e => {
  if (e.key === 'Enter' && !e.shiftKey && !e.isComposing && e.keyCode !== 229) { e.preventDefault(); schicke(); }
});
// „Chat starten“
addEventListener('click', e => {
  if (e.target.closest && e.target.closest('[data-tsc-chat],[data-tx-chat-oeffnen]')) { e.preventDefault(); e.stopImmediatePropagation(); oeffnen(); }
}, true);
document.addEventListener('visibilitychange', () => planeAbfrage(1));
MQ.addEventListener('change', () => { anpassen(); linsePlanen(); });
WENIG.addEventListener('change', linsePlanen);
if (VV) { VV.addEventListener('resize', anpassen); VV.addEventListener('scroll', anpassen); }
addEventListener('resize', () => { anpassen(); planen(); });
addEventListener('pointermove', e => {
  if (e.pointerType !== 'mouse' || !FEIN.matches || RUHIG.matches) return;
  lx = e.clientX; ly = e.clientY;
  if (!lf) lf = requestAnimationFrame(licht);
}, { passive: true });
// fest; ueberKonfigurator: öffnet darüber
try { Object.defineProperty(window, 'TXChat', { value: Object.freeze({ oeffnen, schliessen, ueberKonfigurator: true }) }); } catch (e) {}

function einhaengen() {
  document.body.append(host);
  umgebung();
  new MutationObserver(planen).observe(document.body, { childList: true });
  linsePlanen();
  if (API && merk && merk.m == 'mensch') { begruesst = true; verlauf(); }   // rote Zahl
}
if (document.body) einhaengen(); else document.addEventListener('DOMContentLoaded', einhaengen, { once: true });
})();
